import React from 'react';
import { StyledAutoSlider } from './ImageCarousel.styles';
import { CarouselProps } from './ImageCarousel.types';

/**
 * Carousel uses React Awesome Slider
 * See here for props and explanations https://github.com/rcaferati/react-awesome-slider#main-props
 */
export const ImageCarousel: React.FC<CarouselProps> = ({ images, carouselOptions }) => {
  const defaultOptions = {
    className: null,
    cssModule: null,
    name: 'awesome-slider',
    selected: 0,
    bullets: true,
    organicArrows: true,
    fillParent: false,
    infinite: true,
    startupScreen: null,
    startup: true,
    transitionDelay: 0,
    mobileTouch: true,
    buttons: true,
    buttonContentRight: null,
    buttonContentLeft: null,
    customContent: null,
    onFirstMount: null,
    onTransitionEnd: null,
    onTransitionStart: null,
    onTransitionRequest: null,
    play: false,
    interval: 0,
  };
  return (
    <StyledAutoSlider
      {...defaultOptions}
      {...carouselOptions}
      media={images.map((img) => ({ source: img.url }))}
    />
  );
};
